import React, { useState } from 'react';
import { ApButtonMain } from '@alixpartners/ui-components';
import { CommonDialog } from '../../CommonDialog';
import { ImportData } from '../../ImportData';
import {
	Wrapper,
	ImageContainer,
	TextContainer,
	Title,
	Text,
	Actions,
	ScrollContainer,
} from './NoData.styles';

export const NoData = ({ fetchData }) => {
	const [isModalOpen, setModalOpen] = useState();
	const showImportModal = () => {
		setModalOpen(true);
	};

	const hideImportModal = () => {
		setModalOpen(false);
	};

	return (
		<ScrollContainer>
			<Wrapper>
				<ImageContainer />
				<TextContainer>
					<Title>There’s currently no data to display</Title>
					<Text>Please upload the data to the system</Text>
					<Actions>
						<ApButtonMain iconName="upload_outlined" onClick={showImportModal}>
							Import data
						</ApButtonMain>
					</Actions>
				</TextContainer>
			</Wrapper>
			{isModalOpen && (
				<CommonDialog
					onClose={hideImportModal}
					body={<ImportData fetchBudget={fetchData} />}
					title="Import data"
					maxWidth={640}
					suppressFooter
				/>
			)}
		</ScrollContainer>
	);
};
